module.exports = __webpack_public_path__ + "img/cough.f306f8d2.svg";